import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useMarkDefaultForIncome() {
  const queryClient = useQueryClient()

  const action = async (id) => {
    const response = await httpClient.post(
      `/team/vault/${id}/mark-default-for-income`,
    )
    return response.data
  }

  return useMutation({
    mutationFn: action,
    onSuccess: (e) => {
      toast.success(e?.response?.data?.message ?? 'Changes saved successfully')
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
    },
    onError: (e) => {
      toast.error(
        e?.response?.data?.message ?? 'Something went wrong. Please try again.',
      )
    },
  })
}
